module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "Vfooter"
  }, [_c('div', {
    staticClass: "footer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer-b"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "footer-b-r"
  }, [_c('p', {
    staticClass: "recommend"
  }, [_c('span', [_vm._v("推荐游戏:")]), _vm._v(" "), _c('a', {
    domProps: {
      "innerHTML": _vm._s(_vm.messg)
    }
  })]), _vm._v(" "), _vm._m(2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("健康游戏忠告")]), _vm._v(" "), _c('li', [_vm._v("抵制不良游戏")]), _vm._v(" "), _c('li', [_vm._v("拒绝盗版游戏")]), _vm._v(" "), _c('li', [_vm._v("注意自我保护")]), _vm._v(" "), _c('li', [_vm._v("谨防受骗上当")]), _vm._v(" "), _c('li', [_vm._v("适度游戏益脑")]), _vm._v(" "), _c('li', [_vm._v("沉迷游戏伤身")]), _vm._v(" "), _c('li', [_vm._v("合理安排时间")]), _vm._v(" "), _c('li', [_vm._v("享受健康生活")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-b-l"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "logo"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "footer-laster"
  }, [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备17047652号-1")]), _vm._v(" "), _c('a', [_vm._v("粤网文 [2017] 3918-769号")]), _vm._v(" "), _c('a', [_vm._v("深圳魔力数娱网络科技有限公司 ©版权所有")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-863f9418","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component/footer.vue
// module id = 56
// module chunks = 70